import { render, staticRenderFns } from "./ShipmentItemsTab.vue?vue&type=template&id=20696284&scoped=true&"
import script from "./ShipmentItemsTab.vue?vue&type=script&lang=js&"
export * from "./ShipmentItemsTab.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentItemsTab.vue?vue&type=style&index=0&id=20696284&lang=scss&scoped=true&"
import style1 from "./ShipmentItemsTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20696284",
  null
  
)

export default component.exports